import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import sl from '@vee-validate/i18n/dist/locale/sl.json'
import {
    required,
    email,
    min,
    max,
    numeric,
    min_value,
    max_value,
    url,
    alpha_num,
    confirmed
} from '@vee-validate/rules'
import { defineRule, configure } from 'vee-validate'

defineRule('numeric', numeric)
defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('max', max)
defineRule('min_value', min_value)
defineRule('max_value', max_value)
defineRule('confirmed', confirmed)
defineRule('url', url)
defineRule('alpha_num', alpha_num)

defineRule('json', (value: string) => {
    try {
        if (value.length > 0) JSON.parse(value)
        return true
    } catch(error) {
        return false
    }
})

defineRule('alpha_num', (value: string) => {
    const re = /^[a-zA-Z0-9._/-]*$/
    return re.test(value)
})

defineRule('at_least_one_uppercase', (value: string) => {
    const re = /[A-Z]/g
    return re.test(value)
})

defineRule('at_least_one_digit', (value: string) => {
    const re = /\d/g
    return re.test(value)
})

configure({
    generateMessage: localize({
        en: {
            messages: {
                ...en.messages,
                'at_least_one_uppercase': 'The {field} field must contain at least one uppercase letter',
                'at_least_one_digit': 'The {field} field must contain at least one digit'
            }
        },
        sl: {
            messages: {
                ...sl.messages,
                'at_least_one_uppercase': 'Polje {field} mora vsebovati vsaj eno veliko črko',
                'at_least_one_digit': 'Polje {field} mora vsebovati vsaj eno številko'
            }
        }
    })
})
